import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { InventoryMovementDTO } from '../../../types/inventory/InventoryMovementTypes';

/**
 * Estado global para la gestión de movimientos de inventario.
 */
interface InventoryMovementState {
    list: InventoryMovementDTO[]; // 🔵 Lista de movimientos paginados
    paginator: any;               // 🔵 Datos de paginación
    isLoading: boolean;           // 🔵 Indicador de carga
}

/**
 * Estado inicial del slice de movimientos de inventario.
 */
const initialState: InventoryMovementState = {
    list: [],
    paginator: null,
    isLoading: false,
};

/**
 * Slice de Redux Toolkit para manejar el estado de movimientos de inventario.
 */
const inventoryMovementSlice = createSlice({
    name: 'inventoryMovement',
    initialState,
    reducers: {
        /**
         * Establece la lista de movimientos y el paginador.
         */
        setMovementList(state, action: PayloadAction<{ content: InventoryMovementDTO[]; paginator: any }>) {
            state.list = action.payload.content;
            state.paginator = action.payload.paginator;
        },

        /**
         * Limpia la lista de movimientos y resetea el paginador.
         */
        clearMovementList(state) {
            state.list = [];
            state.paginator = null;
        },

        /**
         * Actualiza el indicador de carga (`isLoading`).
         */
        setIsLoadingMovements(state, action: PayloadAction<boolean>) {
            state.isLoading = action.payload;
        },
    }
});

// Exportación de acciones
export const { setMovementList, clearMovementList, setIsLoadingMovements } = inventoryMovementSlice.actions;

// Exportación del reducer
export default inventoryMovementSlice.reducer;
